import { useUnArchiveContractMutation } from "@/app/api/slices/rotationCalendarApiSlice";
import { ButtonLoader } from "@/components/ButtonLoader";
import { Button } from "@/components/ui/button";
import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from "@/components/ui/dialog";
import { useToast } from "@/components/ui/use-toast";
import { handleServerErrors } from "@/utils/handleServerErrors";
import { ArchiveRestore } from "lucide-react";
import { useState } from "react";

type Props = { contractId: string | number | undefined | null, vesselId: string | number | undefined | null, disabled?: boolean};

export const UnarchiveContractDialog = ({ contractId, vesselId, disabled=false }: Props) => {
	const { toast } = useToast();
	const [open, setOpen] = useState(false);
	const [unarchiveCrewMemberMutation, { isLoading }] = useUnArchiveContractMutation();

	const handleArchiveContract = async () => {
		if(!vesselId || !contractId) return;
		await unarchiveCrewMemberMutation({ vesselId, contractId })
			.unwrap()
			.then((_payload) => {
				setOpen(false);
				toast({
					variant: "success",
					title: "Successfully unarchived the contract",
				});
			})
			.catch((error) => handleServerErrors(error, toast));
	};
	return (
		<Dialog open={open} onOpenChange={setOpen}>
			<DialogTrigger asChild>
				<Button className="w-8 h-8 p-0" variant="outline" size="icon" style={{ background: "#36f4a2" }} disabled={disabled}>
					<ArchiveRestore color="#fff" height={16} />
				</Button>
			</DialogTrigger>
			<DialogContent className="max-h-full sm:max-w-[500px]">
				<DialogHeader>
					<DialogTitle>Are you absolutely sure?</DialogTitle>
					<DialogDescription>
						This action will unarchive the contract for a selected user. Only one contract can be active at a time.
					</DialogDescription>
				</DialogHeader>
				<div className="flex justify-between">
					<DialogClose asChild>
						<Button type="button" variant="secondary">
							Cancel
						</Button>
					</DialogClose>
					<Button onClick={handleArchiveContract} disabled={isLoading}>
						<ButtonLoader isLoading={isLoading} />
						Continue
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
};
